module.exports = __webpack_public_path__ + "static_pc/img/12.f56c5b1d.png";